export function pruneTabSectionsToTabIds({
  tabSections,
  tabIds,
}: {
  tabSections: Record<string, Record<string, string>>;
  tabIds: ReadonlySet<string>;
}): Record<string, Record<string, string>> {
  return Object.fromEntries(
    Object.entries(tabSections)
      .map(([scope, byTabId]) => {
        const nextByTabId = Object.fromEntries(
          Object.entries(byTabId).filter(([tabId]) => tabIds.has(tabId)),
        );
        return [scope, nextByTabId] as const;
      })
      .filter(([, byTabId]) => Object.keys(byTabId).length > 0),
  );
}
